import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import "react-toastify/dist/ReactToastify.css";
import { removeConsoleLogs } from "./Utils/removeConsole";
// import { socket } from './Utils/socket';
import getStorageData from "./Utils/getStorageData";
import { adminRoutes } from "./routes/Admin";
import SendOtp from "./pages/Authentication/SendOtp";
import VerifyOTP from "./pages/Authentication/VerifyOtp";
import { SocketProvider } from "./Utils/socket";
import AppUpdateNotifier from "./components/Common/AppUpdateNotifier";

const App = () => {
  const userDetails = getStorageData()?.user;

  useEffect(() => {
    const clarity = (window as any).clarity;
    if (clarity && (userDetails as any)?.id) {
      clarity("set", "user_id", (userDetails as any)?.id.toString());
    }
  }, [userDetails]);

  const Layout = VerticalLayout;
  const userType = getStorageData().userType;

  const isAuthorized = localStorage.getItem("Authorization");
  const authProtectedRoutes = userType === 0 ? adminRoutes : [];

  const publicRoutes = [
    { path: "/", component: <SendOtp /> },
    { path: "/verify-otp", component: <VerifyOTP /> },
  ];

  return (
    <SocketProvider>
      <React.Fragment>
        <AppUpdateNotifier />

        <Routes>
          {!isAuthorized &&
            publicRoutes.map((route: any, idx: any) => (
              <Route
                path={route.path}
                element={<NonAuthLayout>{route.component}</NonAuthLayout>}
                key={idx}
              />
            ))}
          {isAuthorized &&
            authProtectedRoutes.map((route: any, idx: any) => (
              <Route
                path={route.path}
                element={
                  <Authmiddleware>
                    <Layout>{route.component}</Layout>
                  </Authmiddleware>
                }
                key={idx}
              />
            ))}
          <Route
            path="*"
            element={
              isAuthorized ? (
                <Navigate
                  to={
                    userType === 4 || userType === 1 ? "/dashboard" : "/search"
                  }
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Routes>
      </React.Fragment>
    </SocketProvider>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
